import { createStore } from 'zustand'

import { TableContextMenuStore } from './interface'

export const createTableContextMenuStore = () =>
  createStore<TableContextMenuStore>((set, get) => ({
    rowCountTop: 1,
    rowCountBottom: 1,
    columnCountLeft: 1,
    columnCountRight: 1,
    setRowColCount({
      rowCountTop,
      rowCountBottom,
      columnCountLeft,
      columnCountRight
    }) {
      set(state => ({
        rowCountTop: rowCountTop ?? state.rowCountTop,
        rowCountBottom: rowCountBottom ?? state.rowCountBottom,
        columnCountLeft: columnCountLeft ?? state.columnCountLeft,
        columnCountRight: columnCountRight ?? state.columnCountRight
      }))
    }
  }))
